/**
 */
export default function safeType<T>(val: T | undefined, defaultVal: T): T {
  if (val === undefined) {
    return defaultVal;
  }
  return val;
}
